export enum ReleaseDateOptions {
    NOW = "now",
    ENDOFDAY = "eod",
    ENDOFWEEK = "eow",
    CUSTOM = "custom",
    NEVER = "never",
    EXISTING = "existing",
}
